module.exports = __webpack_public_path__ + "img/software_zencase.5822f6a2.jpg";